/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {  useState, ChangeEvent, FormEvent, useEffect }from 'react'
import './styles.css'
import { useHistory } from 'react-router-dom'
import { FaCamera } from 'react-icons/fa'

import MultiSelect from '../../components/MultiSelect';

import {MainHeader} from '../../components/Header';
import { Footer } from '../../components/Footer'
import axios from 'axios'
import { toast } from 'react-toastify'

import defaultImage from '../../assets/default-avatar.png';
import api from '../../services/api'
import { phoneNumberMask, postalCodeMask, unMask } from '../../utils/masks';
import getImageProfession from '../../utils/imagesProfession';

interface Item {
    id: number,
    name: string,
    specialties?: Item[],
    image_url?: string
}

interface IBGEUfResponse {
    sigla: string
}

interface IBGECityResponse {
    nome: string
}

interface SelectProps {
    value: string;
    label: string;
}
  
const toastOptions = {
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  };

const Register = () => {
    const [categories, setCategories] = useState<Item[]>();
    const [specialties, setSpecialties] = useState<SelectProps[]>([]);
    const [agreements, setAgreements] = useState<SelectProps[]>([]);
    const [ufs, setUfs] = useState<string[]>([]);
    const [cities, setCities] = useState<string[]>([]);
    const [formData, setFormData] = useState({name:'', email:'', whatsapp:'', password: '', phone: '', registration_number: '', link_instagram: '', link_facebook: '', link_site: '',
    postal_code: '',
	street: '',
	street_number: '',
	neighborhood: '',
	complement: '',
    city: '',
    state: '',
});
    const [description, setDescription] = useState('');

    const [selectedUf, setSelectedUf] = useState('MG');
    const [selectedCity, setSelectedCity] = useState('0');
    const [selectedCategory, setSelectedCategory] = useState<number>();
  
    const [selectedPosition, setSelectedPosition] = useState<[number, number]>([0, 0]);
    const [initialPosition, setInitialPosition] = useState<[number, number]>([0, 0]);
    const history = useHistory();

    const [image, setImage] = useState<string | ArrayBuffer | null>(null);
    const [imageFileName, setImageFileName] = useState<any>(null);

  const [specialtiesSelected, setSpecialtiesSelected] = useState<SelectProps[]>([]);
  const [agreementsSelected, setAgreementsSelected] = useState<SelectProps[]>([]);

    const loadCategories = async () => {   
        await api.get('/categories')
            .then((res) => {
                const categoriesResult = res.data.map((category: Item) => ({...category, image_url: getImageProfession(category.name)}));
                setCategories(categoriesResult);
            })
    }

    const loadSpecialties = async () => {   
        const category = categories?.filter(category => category.id === selectedCategory)[0];

        if(category?.id) {
            const response = category.specialties?.map((specialty) => ({value: String(specialty.id), label: specialty.name }));
        
            if(response){
                setSpecialties(response);
            }
        }
    }

    const loadAgreements = async () => {   
        await api.get('/agreements')
            .then((res) => {
                const response = res.data.map((agreement: Item) => ({value: agreement.id, label: agreement.name }));
                setAgreements(response);
            })
    }
    
    useEffect(() => {
        loadCategories();
        loadAgreements();
    }, []);

    useEffect(() => {
        loadSpecialties();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCategory])

    useEffect(() => {
        navigator.geolocation.getCurrentPosition(
          position => {
            const { latitude, longitude } = position.coords;
    
            setInitialPosition([latitude, longitude]);
          },
          () => {
            toast.error('❌ Oops! Algo deu errado =/', toastOptions);
          },
          {
            timeout: 30000,
            enableHighAccuracy: true,
          },
        );
      }, []);

    useEffect(() => {
        axios.get<IBGEUfResponse[]>('https://servicodados.ibge.gov.br/api/v1/localidades/estados')
        .then(response => {
            const siglas = response.data.map(uf => uf.sigla)
            setUfs(siglas)
        })
    }, [])

    useEffect(() => {
        if(selectedUf === '0'){
            return
        }

        axios.get<IBGECityResponse[]>(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${selectedUf}/municipios`)
        .then(response => {
            const cityNames = response.data.map(city => city.nome)
            setCities(cityNames)
        })
    }, [selectedUf])

function handleSelectedUf (event: ChangeEvent<HTMLSelectElement>){
    const uf = event.target.value
    setSelectedUf(uf)
}

function handleSelectedCity (event: ChangeEvent<HTMLSelectElement>){
    const city = event.target.value
    setSelectedCity(city)
}

function handleInputChange (event: ChangeEvent<HTMLInputElement>){
    const {name, value} = event.target

    setFormData({ ...formData, [name]: value})
}

function handleSelectedCategory (id: number){
     
    if(selectedCategory === id){
        setSelectedCategory(undefined)
    } else {
        setSelectedCategory(id)
    }
}

async function registerSpecialties(providerId: string) {
    const formatSpecialtiesSelected = specialtiesSelected.map(specialty => ({ specialtyId: specialty.value, providerId }));
   
    formatSpecialtiesSelected.forEach(async (specialty) => {
        await api.post('/providers-specialties', specialty);
    });
}

async function registerAgreements(providerId: string) {
    const formatAgreementsSelected = agreementsSelected.map(agreement => ({ agreementId: agreement.value, providerId }));
   
    formatAgreementsSelected.forEach(async (agreement) => {
        await api.post('/providersAgreements', agreement);
    });
}

async function handleSubmit(event: FormEvent) {
    event.preventDefault()
    if(!selectedCategory){
        toast.info('Selecione a sua profissão antes de finalizar!');
        return;
    }

    const { 
        name, 
        email,
        password,
        phone,
        postal_code,
        street,
        street_number,
        neighborhood,
        complement,
        city,
        state,
        registration_number,
        link_facebook,
        link_instagram,
        link_site } = formData
    const [latitude, longitude] = selectedPosition
    const items = selectedCategory;

    const data = {
        name,
        email,
        password,
        phone,
        description,
        registration_number,
        evaluation: 0,
        postal_code: unMask(postal_code),
        street,
        street_number,
        neighborhood,
        complement: complement || undefined,
        city,
        state,
        geo: {
            x: latitude,
            y: longitude,
        },
        categoryId: selectedCategory,
        businessHour: 'Horário comercial',
        isChat: true,
        isPhone: true,
        link_instagram: link_instagram || undefined,
        link_facebook: link_facebook || undefined,
        link_site: link_site || undefined,
    };

    try {
        const response = await api.post('/providers', data);

        const provider_id = response.data.id;


        if(imageFileName) {
            const formDataAvatar = new FormData();

            formDataAvatar.append('avatar', imageFileName);

            const config = { headers: {  
                Authorization: `Bearer 8a9aea2219f67fb5051b5b066f67849a`,
                'Content-Type': 'multipart/form-data',
                } 
            };
        
            await api.patch(`/providers/avatar/${provider_id}`, formDataAvatar, config);
        }

        registerSpecialties(provider_id);
        
        registerAgreements(provider_id);

        if(provider_id){
            history.push('/signin-success');    
        }

    } catch (error) {
        console.log(error)
        toast.error('Erro ao realizar o cadastro. Tente novamente mais tarde.', toastOptions);
    }  
}

const onSelectFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
     
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.addEventListener('load', () => {
        setImage(reader.result);
      
      });

      setImageFileName(event?.target?.files[0]);
    }
  };

  const checkCEP = (e: any) => {
    const cep = e.target.value.replace(/\D/g, '');

    if (cep.length !== 8) {
      toast({
        status: 'info',
        title: 'Informe um CEP válido',
        position: 'top',
        duration: 3000,
      });
      return;
    }

    fetch(`https://viacep.com.br/ws/${cep}/json/`)
      .then(res => res.json())
      .then(data => {
        if (!data.uf) {
          toast({
            status: 'info',
            title: 'Não conseguimos localizar este CEP',
            position: 'top',
            duration: 3000,
          });
          return;
        }

        setFormData({ 
            ...formData, 
            street: data.logradouro, 
            neighborhood: data.bairro, 
            complement: data.complemento,
            city: data.localidade,
            state: data.uf
        })

 
       
      });
  };

    return (
        <div>
  
        <MainHeader />

      <div style={{backgroundColor: '#555FD2', display: 'flex'}}>

   
        <div id="page-create-point">
           
            <form onSubmit={handleSubmit}>
                <h1>Cadastro de profissional da saúde</h1>
                {/* <p>Seu e-mail e senha serão utilizados para entrar no aplicativo</p> */}

                <fieldset>
                    <legend>
                      Dados pessoais
                    </legend>

                    <div id="img-container">
                  <div id="img-default">


                <div id="button-camera">
                  <input
                    type="file"
                    id="selectedFile"
                    accept="image/*"
                    multiple={false}
                    style={{ display: 'none' }}
                    onChange={onSelectFile}
                  />
                  <button
                    type="button"
                    onClick={() =>
                      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                      document.getElementById('selectedFile')!.click()
                    }
                  >
                      <FaCamera style={{fontSize: '1.5rem'}} />
                  </button>
                  </div>
         
                    <img
                        className='header-image'
                      src={
                        imageFileName ? URL.createObjectURL(imageFileName) : defaultImage
                      }
                      alt={'Foto de perfil'}
                      onError={e => {
                        const imgElement = e.target as HTMLImageElement;
                        imgElement.src = defaultImage;
                      }}
                    />

         </div>

         <p id="photo-legend">Coloque um boa foto. Ela aparecerá no seu perfil!</p>
                </div>

                    <div className="field">
                        <label htmlFor="name">Nome completo</label>
                        <input required maxLength={50} type="text" name="name" id="name" onChange={handleInputChange} placeholder="Digite seu nome completo"/>
                    </div>

                    <div className="field-group">
                        <div className="field">
                            <label htmlFor="email">E-mail</label>
                            <input placeholder='Digite seu email' required maxLength={100} type="email" name="email" id="email" onChange={handleInputChange}/>
                        </div>
                        <div className="field">
                            <label htmlFor="phone">Telefone</label>
                            <input placeholder='Digite seu telefone' value={phoneNumberMask(formData.phone)} required maxLength={20} type="text" name="phone" id="phone" onChange={handleInputChange}/>
                        </div>
                    </div>

                     <div className="field-group">
                    <div className="field">
                            <label htmlFor="password">Crie uma senha</label>
                            <input placeholder='*******' required type="password" name="password" id="password" onChange={handleInputChange}/>
                        </div>
                        <div className="field">
                            <label htmlFor="password">Repita sua senha</label>
                            <input placeholder='*******' required type="password" name="password" id="password" onChange={handleInputChange}/>
                        </div>
                    </div>
                    
                    </fieldset>

                    <fieldset>
                    <legend>
                       Dados profissionais
                    </legend>

                    <div className="field">
                        <label htmlFor="registration_number">Número de registro (ex. CRM, CRP, CRO)</label>
                        <input placeholder='Digite seu número de registro' required maxLength={15} type="text" name="registration_number" id="registration_number" onChange={handleInputChange}/>
                    </div>

                    <div className="field-group">
                        
                    <div className="field">
                            <label htmlFor="description">Descreva um pouco sobre você</label>
                            <textarea required maxLength={500} rows={8} onChange={(e) => setDescription(e.target.value)} name="description" id="description" placeholder='Qual é a sua área de especialização? Qual é a sua experiência? Quais são as suas conquistas?'></textarea>
                        </div>
                    </div>

                    <div className="field-group">
                    <div className="field">
                            <label htmlFor="link_instagram">Usuário do Instagram</label>
                            <input placeholder='buscasaude' type="text" name="link_instagram" id="link_instagram" onChange={handleInputChange}/>
                        </div>
                        <div className="field">
                            <label htmlFor="link_facebook">Usuário do Facebook</label>
                            <input placeholder='buscasaude' type="text" name="link_facebook" id="link_facebook" onChange={handleInputChange}/>
                        </div>
                    </div>

                    <div className="field-group">
                        <div className="field">
                            <label htmlFor="link_site">Site</label>
                            <input placeholder='Digite o endereço do seu site (Deixe em branco caso não tenha um site)' type="text" name="link_site" id="link_site" onChange={handleInputChange}/>
                        </div>
                      
                    </div>
                    
                    </fieldset>
              

                <fieldset>
                    <legend>
                      Endereço
                        <span>Informe o endereço onde você atende</span>
                    </legend>

                    <div className="field-group">
                    <div className="field">
                            <label htmlFor="postal_code">CEP</label>
                            <input required onBlur={checkCEP} value={postalCodeMask(formData.postal_code)} placeholder='35500-000' type="text" name="postal_code" id="postal_code" onChange={handleInputChange}/>
                        </div>
                        <div className="field">
                            <label htmlFor="street">Logradouro</label>
                            <input value={formData?.street} placeholder='Av. 1º de Junho' type="text" name="street" id="street" onChange={handleInputChange}/>
                        </div>
                    </div>

                    <div className="field-group">
                        <div className="field">
                            <label htmlFor="street_number">Número</label>
                            <input placeholder='100' type="text" name="street_number" id="street_number" onChange={handleInputChange}/>
                        </div>
                        <div className="field">
                            <label htmlFor="neighborhood">Bairro</label>
                            <input value={formData?.neighborhood} placeholder='Centro' type="text" name="neighborhood" id="neighborhood" onChange={handleInputChange}/>
                        </div>
                    </div>

                    <div className="field">
                            <label htmlFor="complement">Complemento</label>
                            <input value={formData?.complement} placeholder='Ap 1001' type="text" name="complement" id="complement" onChange={handleInputChange}/>
                        </div>

                
                    <div className="field-group">
                        <div className="field">
                            <label htmlFor="uf">Estado (UF)</label>
                            <input disabled value={formData?.state} placeholder='Seu estado' type="text" name="state" id="state" onChange={handleInputChange}/>
                    
                            {/* <select required name="uf" id="uf" value={selectedUf} onChange={handleSelectedUf}>
                                <option value="0">Selecione uma UF</option>
                                {ufs.map(uf => (
                                    <option key={uf} value={uf}>{uf}</option>
                                ))}
                            </select> */}
                        </div>
                        <div className="field">
                            <label htmlFor="city">Cidade</label>
                            <input disabled value={formData?.city} placeholder='Sua cidade' type="text" name="city" id="city" onChange={handleInputChange}/>
                    
                            {/* <select required name="city" id="city" value={selectedCity} onChange={handleSelectedCity}>
                                <option value="0">Selecione uma cidade</option>
                                {cities.map(city => (
                                    <option key={city} value={city}>{city}</option>
                                ))}
                            </select> */}
                        </div>
                    </div>
                </fieldset>

                <fieldset>
                    <legend>
                        Qual sua profissão?
                        <span>Selecione sua área de atuação</span>
                    </legend>

                    <ul className="items-grid">
                        {categories?.map(item => (
                        <li key={item.id} 
                        onClick={() => handleSelectedCategory(item.id)} 
                        className={selectedCategory === item.id ? 'selected': ''}>
                            <img src={item.image_url} alt={item.name}></img>
                            <span>{item.name}</span>
                        </li>
                        ))}
                    </ul>
                </fieldset>

                <fieldset>
                    <legend>
                        Quais suas especialidades?
                        <span>Selecione suas especialidades</span>
                    </legend>
            
                    <MultiSelect
                        name="specialties"
                        label="Especialidades"
                        placeholder="Selecione suas especialidades"
                        options={specialties}
                        onChange={(e: any) => setSpecialtiesSelected(e)}
                    />
                </fieldset>

                <fieldset>
                    <legend>
                        Quais convênios você atende?
                        <span>Selecione seus convênios</span>
                    </legend>
            
                    <MultiSelect
                        name="agreements"
                        label="Convênios"
                        placeholder="Selecione seus convênios"
                        options={agreements}
                        onChange={(e: any) => setAgreementsSelected(e)}
                    />
                </fieldset>


                <div style={{display: 'flex', alignItems: 'center', marginTop: '3rem'}}>
                <input required type={"checkbox"} name="terms" id="terms" />
                <label htmlFor="terms" style={{marginLeft: 10, marginTop: -2}}>Eu aceito os termos e condições de uso do Busca Saúde.</label>
                </div>
            
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <button type="submit" id="submit-button">
                    Registrar-se gratuitamente
                </button>
                </div>
            </form>
        </div>
        </div>

        <Footer />

        </div>
    )
}

export default Register